import React, { useEffect, useState } from "react";
import { render } from "react-dom";

import { formatDateTime } from "../../../../../scripts/util/dateTime";
import { getFirstOpenSchedulingSlot, IMyChartOpenSchedulingTime } from "../../../../../scripts/util/myChart";

import './ProviderSchedulingBlock.scss';

import icon_img_2 from '../../../../../../prototype/src/assets/images/icon-info-2.svg';


interface IProviderSchedulingEarliestAppointmentProps {
    myChartProviderID: string|number;
    myChartDepartmentID: string|number;
    myChartVisitTypeID: string|number;
}

const ProviderSchedulingEarliestAppointment = ({
    myChartProviderID, myChartDepartmentID, myChartVisitTypeID
}: IProviderSchedulingEarliestAppointmentProps) => {
    const [earliestAppointment, setEarliestAppointment] = useState<IMyChartOpenSchedulingTime>();

    useEffect(() => {
        try {
            getFirstOpenSchedulingSlot(myChartProviderID, myChartDepartmentID, myChartVisitTypeID)
            .then((result) => {
                console.log(`ProviderSchedulingEarliestAppointment(${myChartProviderID},${myChartDepartmentID},${myChartVisitTypeID}) result => ${JSON.stringify(result)}`);
                console.log(`Date Time: ${earliestAppointment?.dateTime}`);
                if(result !== null) {
                    setEarliestAppointment(result);
                }
            });
        } catch(err) {
            console.log(`Error during ProviderSchedulingEarliestAppointment call to getFirstOpenSchedulingSlot: ${err}`);
        }
    }, []);
    return (<>
        {(
            earliestAppointment
                ? <div className="scheduling-earliest-appointment">
                    <label>Earliest New Patient Appointment</label><br/>
                    <span title={earliestAppointment.humanDelta}>{formatDateTime(earliestAppointment.dateTime)} <img src={icon_img_2} /></span>
                </div>
                : null
        )}
    </>);
};

export { ProviderSchedulingEarliestAppointment };
